module.exports = __webpack_public_path__ + "img/custom_illustration_card.137172ba.svg";